
//values for the input ant element
export const initialStatesInput = {
  success: 'success', warning: 'warning',
  error: 'error', validating: 'validating'
}

//regex for validate emails
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;



// return a color value
export const randomColor = (letter) => {
  switch (letter) {
    case "A", "F", "K", "T":
      return '#f56a00';
    case "B", "G", "L", "P":
      return '#7265e6';
    case "C", "H", "M", "Q", "U":
      return '#ffbf00';
    case "D", "I", "N", "R":
      return '#00a2ae';
    case "E", "J", "O", "S":
      return '#E6EE9C';
    default:
      return '#5DADE2';
  }
}